import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline, IconButton } from '@mui/material';
// import { Menu } from '@mui/icons-material';
import { HiMenuAlt1 } from "react-icons/hi";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './components/Login';
import Sidebar from './components/Sidebar';
import UserDropdown from './components/UserDropdown';
import Dashboard from './components/Dashboard';
import SuperAdminDashboard from './components/SuperAdminDashboard';
import OnboardingForms from './components/OnboardingForms';
import AddInfluencer from './components/AddInfluencer';
import StandaloneForm from './components/StandaloneForm';
import SubmittedForms from './components/SubmittedForms';
import NegotiationCost from './components/NegotiationCost';
import Report from './components/Report';
import InfluencerDetail from './components/InfluencerDetail';
import ExistingInfluencers from './components/ExistingInfluencers';
import BarterList from './components/BarterList';
import Marketing from './components/Marketing';
import Masters from './components/Masters';
import CampaignStages from './components/CampaignStages';
import StageDetails from './components/StageDetails';
import CampaignStrategyUpload from './components/CampaignStrategyUpload';
import StrategyApproval from './components/StrategyApproval';
import InfluencerPlanning from './components/InfluencerPlanning';
import InfluencerShortlisting from './components/InfluencerShortlisting';
import BusinessApproval from './components/BusinessApproval';
import InfluencerFinalCosts from './components/InfluencerFinalCosts';
import InfluencerEmpanelment from './components/InfluencerEmpanelment';
import BudgetRelease from './components/BudgetRelease';
import PODispatch from './components/PODispatch';
import ProductRequirement from './components/ProductRequirement';
import ContentCoordination from './components/ContentCoordination';
import LogisticsTeam from './components/LogisticsTeam';
import ContentVideoLive from './components/ContentVideoLive';
import AssetCollection from './components/AssetCollection';
import BillingConfirmation from './components/BillingConfirmation';
import ContactForm from './components/ContactForm';
import FileManager from './components/FileManager';
import ContactList from './components/ContactList';
import IdentifiedInfluencers from './components/IdentifiedInfluencers';
import BriefDetails from './components/BriefDetails';
import CampaignSteps from './components/CampaignSteps';
import StrategyDetails from './components/StrategyDetails';
import InfluencerList from './components/InfluencerList';
import IYData from './components/IYData';
import NotFound from './components/NotFound';
import './styles/sidebar.css';
import './styles/scrollbar.css';
import Sample from './components/Sample';

const theme = createTheme({
  typography: {
    fontSize: 12,
    body1: {
      fontSize: '14px',
    },
    body2: {
      fontSize: '13px',
    },
    h6: {
      fontSize: '15px',
    },
    // button: {
    //   fontSize: '14px',
    // },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiButton: {
      defaultProps: {
        size: 'small',
        variant: 'contained',
      },
      styleOverrides: {
        root: {
          paddingTop: '5px',
          paddingBottom: '5px',
          textTransform: 'none',
        },
        contained: {
          backgroundColor: '#DAFF7C',
          color: '#1a1d29',
          '&:hover': {
            backgroundColor: '#c5e86d',
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: '#F9FAFB',
            fontWeight: 600,
            color: '#333',
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(even)': {
            backgroundColor: '#fafafa',
          },
          '&:hover': {
            backgroundColor: '#f5f5f5',
          },
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#DAFF7C',
      light: '#e5ff9f',
      dark: '#c5e86d',
    },
    secondary: {
      main: '#1a1d29',
      light: '#2a2d39',
      dark: '#0a0d19',
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF',
    },
  },
});

function AppContent() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveMenu = () => {
    if (!user) return 'dashboard';
    const path = location.pathname;
    if (path === '/onboard-forms' || path.startsWith('/influencer/')) return 'onboarding';
    if (path === '/influencers-assign') return 'existing';
    if (path === '/barter-list') return 'barter';
    if (path === '/submitted-forms') return 'submitted';
    if (path === '/negotiation-cost') return 'negotiation';
    if (path === '/brief-details') return 'brief';
    if (path === '/strategy-details') return 'dmteam';
    // if (path === '/campaign-steps/edit/:id') return 'campaignsteps';
    if (path === '/report') return 'report';
    if (path === '/Identified-Influencers' || path.startsWith('/Identified-Influencers/')) return 'contacts';
    if (path === '/iy-data') return 'iydata';
    if (path === '/file-manager') return 'filemanager';
    if (path.startsWith('/marketing')) return 'marketing';
    if (path.startsWith('/campaign-steps')) return 'marketing';
    if (path === '/masters') return 'masters';
    if (path === '/' && user?.role === 'marketing') return 'marketing';
    return 'dashboard';
  };

  const setActiveMenu = (menuId) => {
    switch (menuId) {
      case 'dashboard': navigate('/'); break;
      case 'onboarding': navigate('/onboard-forms'); break;
      case 'existing': navigate('/influencers-assign'); break;
      case 'barter': navigate('/barter-list'); break;
      case 'submitted': navigate('/submitted-forms'); break;
      case 'negotiation': navigate('/negotiation-cost'); break;
      case 'brief': navigate('/brief-details'); break;
      case 'dmteam': navigate('/strategy-details'); break;
      // case 'campaignsteps': navigate('/campaign-steps/edit/:id'); break;
      case 'report': navigate('/report'); break;
      case 'contacts': navigate('/Identified-Influencers'); break;
      case 'iydata': navigate('/iy-data'); break;
      case 'filemanager': navigate('/file-manager'); break;
      case 'marketing': navigate('/marketing'); break;
      case 'masters': navigate('/masters'); break;
      default: navigate('/'); break;
    }
  };

  useEffect(() => {
    const checkTokenExpiration = () => {
      const token = localStorage.getItem('token');
      const userData = localStorage.getItem('user');
      const loginTime = localStorage.getItem('loginTime');

      if (token && userData && loginTime) {
        const currentTime = new Date().getTime();
        const loginTimestamp = parseInt(loginTime);
        const oneHour = 60 * 60 * 1000;

        if (currentTime - loginTimestamp > oneHour) {
          handleLogout();
          return;
        }
        setUser(JSON.parse(userData));
      }
      setLoading(false);
    };

    checkTokenExpiration();

    const interval = setInterval(checkTokenExpiration, 60000);

    return () => clearInterval(interval);
  }, []);

  const handleLogin = (userData) => {
    localStorage.setItem('loginTime', new Date().getTime().toString());
    setUser(userData);
    if (userData?.role === 'marketing') {
      navigate('/marketing');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('loginTime');
    setUser(null);
    navigate('/', { replace: true });
  };

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  if (loading) {
    return <div className="container">Loading...</div>;
  }

  const isStandaloneForm = location.pathname.startsWith('/form/');
  const isNotFoundRoute = !user && !isStandaloneForm &&
    !['/'].includes(location.pathname) &&
    !location.pathname.startsWith('/form/');

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {/* :id -> onboard Id  |existingId form Id | influencer Id   */}
        <Route path="/form/:id/:existingId?/:influencerId?" element={<StandaloneForm />} />

        {/* <Route path="/form/:id/:type?/:existingId?" element={<StandaloneForm />} /> this OTP section*/}
        <Route path="/contact-form/:id" element={<ContactForm />} />
        {user ? (
          <Route path="/*" element={
            <div style={{ display: 'flex' }}>
              <Sidebar
                activeMenu={getActiveMenu()}
                setActiveMenu={setActiveMenu}
                user={user}
                isCollapsed={isCollapsed}
                toggleSidebar={toggleSidebar}
              />
              <div className={`main-content ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
                <div className="top-header">
                  <IconButton
                    onClick={toggleSidebar}
                    sx={{
                      color: 'gray',
                      '&:hover': {
                        bgcolor: 'rgba(255,255,255,0.1)',
                      }
                    }}
                  >
                    <HiMenuAlt1 />
                  </IconButton>
                  <UserDropdown user={user} onLogout={handleLogout} />
                </div>
                <Routes>
                  <Route path="/" element={user.username == 'SA' || user.username == 'ganapathi.e' || user.username == 'varshini.r'  ? <SuperAdminDashboard /> : <Dashboard user={user}/>} />
                  <Route path="/demo" element={<Sample />} />
                  <Route path="/onboard-forms" element={<OnboardingForms user={user} />} />
                  <Route path="/onboard-forms/new" element={<AddInfluencer />} />
                  <Route path="/influencer/:id" element={<InfluencerDetail />} />
                  {/* <Route path="/existing-influencers" element={<ExistingInfluencers user={user} />} /> */}
                  <Route path="/influencers-assign" element={<ExistingInfluencers user={user} />} />
                  <Route path="/barter-list" element={<BarterList />} />
                  {/* <Route path="/brief-details" element={<BriefDetails />} /> */}
                  <Route path="/campaign-steps/edit/:id" element={<CampaignSteps user={user} />} />
                  <Route path="/strategy-details/edit/:id" element={<StrategyDetails />} />
                  <Route path="/submitted-forms" element={<SubmittedForms />} />
                  <Route path="/negotiation-cost" element={<NegotiationCost user={user} />} />
                  <Route path="/brief-details/edit/:id" element={<BriefDetails />} />
                  <Route path="/report" element={<Report />} />
                  <Route path="/Identified-Influencers" element={<IdentifiedInfluencers />} />
                  <Route path="/Identified-Influencers/:id" element={<ContactList />} />
                  <Route path="/file-manager" element={<FileManager />} />
                  <Route path="/influencer-list" element={<InfluencerList />} />
                  <Route path="/iy-data" element={<IYData user={user} />} />
                  <Route path="/marketing" element={<Marketing user={user} />} />
                  <Route path="/marketing/edit/:id" element={<CampaignStages />} />
                  <Route path="/marketing/edit/:id/stage/:stageId" element={<StageDetails />} />
                  <Route path="/marketing/edit/:id/strategy/:stageId" element={<CampaignStrategyUpload />} />
                  <Route path="/marketing/edit/:id/approval/:stageId" element={<StrategyApproval />} />
                  <Route path="/marketing/edit/:id/planning/:stageId" element={<InfluencerPlanning />} />
                  <Route path="/marketing/edit/:id/shortlisting/:stageId" element={<InfluencerShortlisting />} />
                  <Route path="/marketing/edit/:id/business-approval/:stageId" element={<BusinessApproval />} />
                  <Route path="/marketing/edit/:id/final-costs/:stageId" element={<InfluencerFinalCosts />} />
                  <Route path="/marketing/edit/:id/empanelment/:stageId" element={<InfluencerEmpanelment />} />
                  <Route path="/marketing/edit/:id/budget-release/:stageId" element={<BudgetRelease />} />
                  <Route path="/marketing/edit/:id/po-dispatch/:stageId" element={<PODispatch />} />
                  <Route path="/marketing/edit/:id/product-requirement/:stageId" element={<ProductRequirement />} />
                  <Route path="/marketing/edit/:id/content-coordination/:stageId" element={<ContentCoordination />} />
                  <Route path="/marketing/edit/:id/logistics/:stageId" element={<LogisticsTeam />} />
                  <Route path="/marketing/edit/:id/content-live/:stageId" element={<ContentVideoLive />} />
                  <Route path="/marketing/edit/:id/asset-collection/:stageId" element={<AssetCollection />} />
                  <Route path="/marketing/edit/:id/billing-confirmation/:stageId" element={<BillingConfirmation />} />
                  <Route path="/masters" element={<Masters />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
                {/* <div className="bottom-footer">
                  <p>© 2025 Brandfluence. All rights reserved.</p>
                </div> */}
              </div>
            </div>
          } />
        ) : (
          <>
            <Route path="/" element={<Login onLogin={handleLogin} />} />
            <Route path="*" element={<NotFound />} />
          </>
        )}
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
